import { useDispatch, useSelector } from "react-redux";
import { updateTutorialState } from "./TutorialActions";

const useTutorialState = (tutorialType) => {
  const activeStep = useSelector((state) => state.tutorials_states.activeStep);
  const isTutorial = useSelector((state) => state.tutorials_states.isTutorial);
  const activeTutorial = useSelector(
    (state) => state.tutorials_states.activeTutorial
  );

  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(updateTutorialState({ activeStep: activeStep + 1 }));
  };

  const showStep = isTutorial && activeTutorial === tutorialType;
  
  return {
    activeStep,
    handleNext,
    showStep,
  };
};

export default useTutorialState;
